export const NoxusLoadingPulse = ({ size = 25 }: { size?: number }) => {
  return (
    <>
      <style jsx>{`
        @keyframes rotate-scale {
          0% {
            transform: rotate(0deg) scale(1);
            opacity: 0.75;
          }
          50% {
            transform: rotate(0) scale(1.2);
            opacity: 1;
          }
          100% {
            transform: rotate(0) scale(1);
            opacity: 0.75;
          }
        }
        .noxus-pulse {
          animation: rotate-scale 1s infinite ease;
        }
      `}</style>
      <div className="transition-opacity duration-1000 ease-in-out">
        <img
          src="https://storage.googleapis.com/image-storage-spot-manual/app/sidenav/noxus-o.svg"
          alt="Noxus logo"
          width={size}
          height={size}
          className="noxus-pulse dark:invert dark:brightness-0"
        />
      </div>
    </>
  );
};
